import { ShareCampaignRoles } from "../types/enums";

export const useGetUserShareCampaignRoles = (roles?: ShareCampaignRoles[]) => {
  if (!roles)
    return {
      isOwner: false,
      isAdmin: false,
      isEditor: undefined,
      isOnlyViewer: false,
    };

  const isOwner = roles.includes(ShareCampaignRoles.owner);
  const isAdmin = roles.some((role) =>
    [ShareCampaignRoles.owner, ShareCampaignRoles.admin].includes(role),
  );
  const isEditor = roles.includes(ShareCampaignRoles.editor);
  const isOnlyViewer = !isOwner && !isEditor;

  return { isOwner, isAdmin, isEditor, isOnlyViewer };
};
